import React from 'react';
import { TrendingUp } from 'lucide-react';

export type VersionBadgeVariant = 'current' | 'minor' | 'major';

interface VersionBadgeProps {
	version: string;
	variant: VersionBadgeVariant;
	icon?: React.ReactNode;
	className?: string;
}

const variantStyles = {
	current: {
		strongColor: '#EFAD29',
		lightColor: '#F9ECCD',
		textColor: '#8B6914'
	},
	minor: {
		strongColor: '#7CB342',
		lightColor: '#E3F9CD',
		textColor: '#4A7A28'
	},
	major: {
		strongColor: '#2687DC',
		lightColor: '#CDE6F9',
		textColor: '#1A5A9A'
	}
};

export default function VersionBadge({ version, variant, icon, className = '' }: VersionBadgeProps) {
	const colors = variantStyles[variant];
	const IconComponent = icon || <TrendingUp className="w-2.5 h-2.5" />;

	return (
		<div 
			className={`inline-flex items-stretch overflow-hidden rounded ${className}`}
			style={{ borderColor: colors.strongColor, borderWidth: '1.5px', borderStyle: 'solid' }}
		>
			{/* Icon Section with strong color */}
			<div
				className="flex items-center justify-center"
				style={{
					backgroundColor: colors.strongColor,
					width: '22px',
					height: '18px'
				}}
			>
				<div style={{ color: 'white' }}>
					{IconComponent}
				</div>
			</div>

			{/* Text Section with light color */}
			<div
				className="flex items-center justify-center px-1.5"
				style={{
					backgroundColor: colors.lightColor,
					height: '18px',
					minWidth: '38px'
				}}
			>
				<span
					className="font-semibold whitespace-nowrap"
					style={{ color: colors.textColor, fontSize: '10px' }}
				>
					{version}
				</span>
			</div>
		</div>
	);
}
